export enum DomLayoutEnum {
  Normal = 'normal',
  AutoHeight = 'autoHeight',
  Print = 'print',
}
